import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fileUrl } from "@/lib/api";

export const Stars = ({ value, size = 14 }) => (
  <span className="inline-flex gap-0.5 text-[#C47A37]" aria-label={`${value} stars`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={size} fill={i <= Math.round(value) ? "currentColor" : "none"} strokeWidth={1.5} />)}
  </span>
);

export default function ProductCard({ p, i = 0 }) {
  const { t, fmt, pick } = useApp();
  const sold = p.type === "physical" && p.stock <= 0;
  const po = sold && p.out_of_stock_mode === "preorder";
  return (
    <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block rise" style={{ animationDelay: `${i * 60}ms` }}>
      <div className="relative aspect-[4/5] overflow-hidden bg-[#F6F2EE]">
        <img src={fileUrl(p.images?.[0])} alt={p.name} loading="lazy" className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${sold && !po ? "brightness-[0.45] grayscale-[30%]" : ""}`} data-testid={`product-cover-${p.slug}`} />
        {p.discount_label && <span data-testid={`badge-discount-${p.slug}`} className="absolute top-3 right-3 bg-[#9E2A2B] text-white px-2 py-1 text-xs font-semibold tracking-wide">{p.discount_label}</span>}
        <span className="absolute top-3 left-3 bg-white/90 backdrop-blur px-2 py-1 text-[10px] font-mono uppercase tracking-[0.15em] text-[#8C4F27]">{t(p.type)}</span>
        {sold && <span data-testid={`badge-${po ? "preorder" : "soldout"}-${p.slug}`} className={`absolute bottom-3 left-3 ${po ? "bg-[#8C4F27]" : "bg-[#3B220C]"} text-white px-2 py-1 text-[10px] uppercase tracking-wider`}>{po ? t("preorder") : t("out_of_stock")}</span>}
      </div>
      <div className="pt-4 space-y-1">
        <h3 className="font-serif text-xl leading-tight group-hover:text-[#8C4F27] transition-colors">{pick(p, "name")}</h3>
        {p.review_count > 0 && <div className="flex items-center gap-1 text-xs text-[#6E6259]" data-testid={`product-rating-${p.slug}`}><Stars value={p.rating} size={12} />({p.review_count})</div>}
        <div className="flex items-baseline gap-1.5 sm:gap-2 whitespace-nowrap overflow-hidden leading-none pt-1" data-testid={`product-price-${p.slug}`}>
          <span className="text-[clamp(11px,3.2vw,15px)] sm:text-[15px] font-medium">{fmt(p.price)}</span>
          {p.original_price && <s className="text-[clamp(9px,2.6vw,12px)] sm:text-xs text-[#6E6259]" data-testid={`product-original-price-${p.slug}`}>{fmt(p.original_price)}</s>}
        </div>
      </div>
    </Link>
  );
}
